import React from 'react';
import Select from 'react-select';

// Select con ricerca (typeahead) per il portale magazzino.
// Wrapper leggero attorno a react-select: API a "value stringa" (come una <select> nativa)
// invece che a oggetto-opzione, così l'integrazione nelle pagine resta semplice.
//
//   <PkgSelect
//     value={orderUuid}                         // stringa (es. uuid) o '' quando vuoto
//     options={[{ value, label }, ...]}
//     onChange={uuid => ...}                     // riceve la stringa value (o '' se azzerato)
//     placeholder="Cerca ordine..."
//     noOptionsText="Nessun ordine"
//     isDisabled isClearable
//   />
//
// La ricerca filtra per label (case-insensitive), quindi funziona anche digitando/scansionando
// una porzione del testo mostrato (numero ordine, cliente, codice articolo, ...).

// Palette allineata ai token di index.css (--blue-dark--color, --yellow--color, --dark--color, --gray-light--color).
const BLUE = '#003049';
const YELLOW = '#fbba00';
const DARK = '#01314a';
const GRAY = '#f6f7f9';
const MUTED = '#6c7a89';

// Target touch e dimensioni pensate per il tablet kiosk (Zebra ET45).
const pkgStyles = {
    // Altezza fissa 48px per combaciare esattamente con gli <input> del portale (.pkg-field input).
    control: (base, state) => ({
        ...base,
        minHeight: 48,
        height: 48,
        borderRadius: 4,
        borderColor: BLUE,
        borderWidth: 1,
        fontSize: 18,
        backgroundColor: state.isDisabled ? GRAY : '#fff',
        boxShadow: state.isFocused ? `0 0 0 2px ${BLUE}33` : 'none',
        ':hover': { borderColor: BLUE },
    }),
    valueContainer: (base) => ({ ...base, height: 46, padding: '0 12px' }),
    input: (base) => ({ ...base, margin: 0, padding: 0, color: DARK }),
    singleValue: (base) => ({ ...base, color: DARK }),
    placeholder: (base) => ({ ...base, color: MUTED }),
    indicatorsContainer: (base) => ({ ...base, height: 46 }),
    dropdownIndicator: (base) => ({ ...base, color: BLUE, padding: '0 8px' }),
    clearIndicator: (base) => ({ ...base, color: MUTED, padding: '0 8px', cursor: 'pointer' }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: '#cfd6dc' }),
    menu: (base) => ({ ...base, zIndex: 30, borderRadius: 4, border: `1px solid ${BLUE}`, overflow: 'hidden' }),
    menuList: (base) => ({ ...base, maxHeight: 320 }),
    option: (base, state) => ({
        ...base,
        padding: '11px 12px',
        minHeight: 44,
        fontSize: 16,
        cursor: 'pointer',
        color: state.isSelected ? '#fff' : DARK,
        backgroundColor: state.isSelected ? BLUE : state.isFocused ? YELLOW : '#fff',
        ':active': { backgroundColor: YELLOW },
    }),
};

const PkgSelect = ({
    value,
    options = [],
    onChange,
    placeholder = 'Cerca...',
    noOptionsText = 'Nessun risultato',
    isDisabled = false,
    isClearable = true,
    ...rest
}) => {
    const selected = options.find((o) => o.value === value) || null;
    return (
        <Select
            options={options}
            value={selected}
            onChange={(opt) => onChange(opt ? opt.value : '')}
            placeholder={placeholder}
            isDisabled={isDisabled}
            isClearable={isClearable}
            noOptionsMessage={() => noOptionsText}
            loadingMessage={() => 'Caricamento...'}
            menuPlacement="auto"
            styles={pkgStyles}
            {...rest}
        />
    );
};

export default PkgSelect;
